import React, { useEffect, useState, useContext } from 'react';
import { useHistory } from 'react-router-dom';
import pricesService from '../../services/pricesService';
import PricesPage from '../../pages/MaestrosPage/PricesPage/PricesPage';
import currencyFormat from '../../utils/formatCOP';
import { Context } from '../../context/Contex';

const PricesContainer = () => {
  const [precios, setPrecios] = useState([]);
  const [update, setUpdate] = useState(false);
  const [loading, setLoading] = useState(false);
  const [scraping, setScraping] = useState({
    segmentacion_uuid: '',
    url: '',
    xpath: '',
    estado: 1,
    save: false,
    open: false,
  });
  // PRECIO_NETO es la columna PRECIO de BigQuery: la que edita el lápiz y la
  // que escribe el scraping. El alias PRECIO del SELECT apunta a
  // PRECIO_SIN_DESCUENTO, que ninguna rutina actualiza y llega NULL. El valor
  // viene como string en notación científica ("1.1499999E7"), así que hay que
  // usar Number y no parseInt, que se detendría en el punto y devolvería 1.
  const formatPrecio = (valor) => {
    if (valor === null || valor === undefined || valor === '') {
      return '';
    }
    const numero = Number(valor);
    return Number.isFinite(numero) ? currencyFormat(numero) : '';
  };

  const history = useHistory();
  const { permisos } = useContext(Context);
  const dataTale = [];

  const COLORS = [
    { checked: true, color: 'primary', estado: 1 },
    { checked: true, color: 'secondary', estado: 0 },
    { checked: false, color: 'disable', estado: 'NULL' },
  ];

  const getPrices = () => {
    setLoading(true);
    pricesService
      .getPrices()
      .then((response) => {
        try {
          response.data.data.forEach((value) => {
            dataTale.push({
              uuid: value.UUID,
              unidades: value.UNIDADES,
              marca: value.MARCA,
              linea: value.LINEA,
              cod_assambler: value.CODIGO_ENSAMBLADORA,
              empresa: value.EMPRESA,
              carroceria: value.CARROCERIA,
              combustible: value.COMBUSTIBLE,
              estado: value.ESTADO,
              scraping: value.SCRAPPING_ESTADO,
              estadoScraping: value.SCRAPPING_ESTADO_PROCESO,
              segmentacion_uuid: value.SEGMENTACION_UUID,
              precio: formatPrecio(value.PRECIO_NETO),
              error:
                value.SCRAPPING_ESTADO === 0
                && value.SCRAPPING_ESTADO_PROCESO === 0
                  ? 'Inactivo'
                  : value.SCRAPPING_ESTADO === 1
                    && value.SCRAPPING_ESTADO_PROCESO === 0
                    ? 'Error'
                    : value.SCRAPPING_ESTADO === undefined
                    && value.SCRAPPING_ESTADO_PROCESO === undefined
                      ? 'Sin scraping'
                      : 'OK',
              tableData:
                value.ESTADO == 1
                  ? COLORS[0]
                  : value.ESTADO == 0
                    ? COLORS[1]
                    : COLORS[2],
            });
          });
        } catch (err) {
          console.log(err);
        }
        setPrecios(dataTale);
        setLoading(false);
      })
      .catch((error) => {
        console.log(error);
        history.push('/home');
        setLoading(false);
      });
  };

  useEffect(() => {
    getPrices();
  }, []);

  /*= =======================================================================
  Update Precios
====================================================== ================== */
  const hadleUpdate = (params) => {
    pricesService
      .putPrices(params)
      .then(() => {
        getPrices();
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
  };

  /*= =======================================================================
  Botón tabla notificación email
====================================================== ================== */
  const handleNotification = () => {
    pricesService
      .postMail()
      .then(() => {
        setUpdate(true);
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
  };

  const handleChangeState = (value) => {
    const newData = precios;
    const index = COLORS.findIndex(
      (item) => item.estado === value.tableData.estado,
    );
    Object.assign(
      newData[value.tableData.id].tableData,
      COLORS[(index + 1) % 3],
    );
    setUpdate(true);
    pricesService
      .postState(newData[value.tableData.id])
      .then(() => {
        console.log('ok');
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
  };

  const handlePriceSelected = async (value) => {
    const response = await pricesService.getScraping(value.segmentacion_uuid);
    setScraping({
      url: '',
      xpath: '',
      estado: 1,
      ...(response || {}),
      segmentacion_uuid: value.segmentacion_uuid,
      open: true,
    });
  };

  const handleSaveScraping = (type, value) => {
    setScraping({ ...scraping, [type]: value });
  };

  const onSaveScraping = async () => {
    const saved = await pricesService.updateScraping(scraping);
    setScraping({
      segmentacion_uuid: '',
      url: '',
      xpath: '',
      estado: 1,
      save: false,
      open: false,
    });
    if (saved) {
      getPrices();
    }
  };

  useEffect(() => {
    setUpdate(false);
  }, [update]);

  return (
    <>
      <PricesPage
        update={update}
        loading={loading}
        precios={precios}
        permisos={permisos}
        scraping={scraping}
        onUpdate={hadleUpdate}
        onSaveScraping={onSaveScraping}
        onChangeState={handleChangeState}
        onNotification={handleNotification}
        handleSaveScraping={handleSaveScraping}
        handlePriceSelected={handlePriceSelected}
      />
    </>
  );
};

export default PricesContainer;
